import { StrictMode } from "react"
import ReactDOM from "react-dom"
import "./index.css"
import { Provider } from "react-redux"
import reportWebVitals from "./reportWebVitals"
import App from "./App"
import "./assets/i18n/i18n"
import { setupInterceptor } from "./utils/http-client/app-client"
import { persistStore } from "redux-persist"
import { PersistGate } from "redux-persist/integration/react"
import store from "./store/store"

const { dispatch } = store

setupInterceptor(dispatch)

ReactDOM.render(
  <StrictMode>
    {/*    store 全域綁定    */}
    <Provider store={store}>
      <PersistGate persistor={persistStore(store)}>
        <App />
      </PersistGate>
    </Provider>
  </StrictMode>,
  document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
